import React, { Fragment } from 'react'
import {useEffect} from 'react';
import {useSelector,useDispatch}  from 'react-redux';
import {gameOver, jump,low,endCount,gamePlayed} from '../actions';
import PlayButton from './playbutton';
import Gameover from './gameover';

const Jumprider = () => {
    const position = useSelector(state => state.carpos);
    const game = useSelector(state => state.game);
    const bottom = String(position)+"rem";
    const gamefinished = useSelector(state => state.gamefinished);
    const dispatch = useDispatch();
    
    const carJump = ()=>{
      dispatch(jump);
      setTimeout(()=>{
        dispatch(low);
        },590)
    }
    
    const carStyle = {
      position: "absolute",
      bottom: bottom,
      left: "0"
    }
  
    const checkCollide=()=>{
      if(document.getElementById("carimg")!==null&&game)
      {
        const car = document.getElementById("carimg").getBoundingClientRect();
        let stone = document.getElementById("stoneimg").getBoundingClientRect();
        let bird = document.getElementById("birdimg").getBoundingClientRect();
        if(bird.x===0&&bird.y===0&&stone.x===0&&stone.y===0)
        return;
        if(bird.x===0&&bird.y===0)
        bird = stone;
        if((car.x<=stone.x && car.width+car.x>=stone.x && car.y<=stone.y && car.height+car.y>=stone.y)||( car.x<=bird.x && car.width+car.x>=bird.x && car.y<=bird.y && car.height+car.y>=bird.y)){
          dispatch(endCount);
          document.getElementById("car").style.display="none";
          document.getElementById("stone").style.display="none";
          document.getElementById("bird").style.display="none";
          document.getElementById("gameover-gif").style.display="block"
          clearInterval(timerid);
          setTimeout(()=>{
            dispatch(gameOver);
            dispatch(gamePlayed);
          },2000);
        }
      }else{
        clearInterval(timerid);
      }
    }
  
    const timerid = setInterval(() => {
        if(game)
        {
          checkCollide();
        }
      },10);
  
    useEffect(() => {
      if(game)
      checkCollide();
      setTimeout(()=>{
        const bird = document.getElementById("bird");
        if(!gamefinished && game && bird)
        document.getElementById("bird").style.display="block";
        },15000
      );
    })

    return (
        <Fragment>
            {game && !gamefinished &&<div id="main-plane" onClick={carJump}>
                <div className="game-title">
                    <h1 className="secondary">JUMP RIDER (Click To Jump)</h1>
                    <PlayButton/>
                </div>
                <div className="road">
                    <img  src="https://cdn.pixilart.com/photos/large/7839761c1cc3eb9.png" alt="road"></img>
                    <div id="car">
                        <img style={carStyle} id="carimg" src="https://thumbs.gfycat.com/FoolhardyInsecureFinnishspitz-size_restricted.gif" alt="car"></img>
                    </div>
                    <div id="stone">
                        <img id="stoneimg" src="https://pngimg.com/uploads/stone/small/stone_PNG13590.png" alt="stone"></img>
                    </div>
                    <div id="bird">
                        <img id="birdimg" src="https://i.pinimg.com/originals/5d/e3/03/5de303950e41d173820c0b6cebae7359.gif" alt="bird"></img>
                    </div>
                    <div id="gameover-gif">
                        <img id="birdimg" src="https://gifimage.net/wp-content/uploads/2017/07/game-over-gif-4.gif" alt="game-over"></img>
                    </div>
                </div>
            </div>}
            {gamefinished && <Gameover/>}
        </Fragment>
    )
}

export default Jumprider


